import React from 'react';
import { Button } from '@material-ui/core';
import { Link, NavLink } from 'react-router-dom';
import BulletedListIcon from '@material-ui/icons/FormatListBulleted';
import NewReleasesIcon from '@material-ui/icons/NewReleases';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
import HelpIcon from '@material-ui/icons/Help';
import ArchiveIcon from '@material-ui/icons/Archive';
import PlusOneIcon from '@material-ui/icons/PlusOne';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import LogoutIcon from '@material-ui/icons/ExitToApp';
import ImportContactsIcon from '@material-ui/icons/ImportContacts';
import Messages from '../../../defs/messages';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

export default function SimpleMenu({ handleCloseMenu }) {
	const [anchorEl, setAnchorEl] = React.useState(null);

	const handleClick = (event) => {
		event.stopPropagation(); // Add this to prevent event bubbling
		setAnchorEl(event.currentTarget);
	};

	const handleClose = (event) => {
		if (event) event.stopPropagation(); // Add this to prevent event bubbling
		setAnchorEl(null);
		if (handleCloseMenu) handleCloseMenu(); // Make this optional with ?
	};
	//TODO: missing keys
	return (
		<div>
			<Button
				aria-controls="simple-menu"
				aria-haspopup="true"
				onClick={handleClick}
			>
				Система
			</Button>
			<Menu
				id="simple-menu"
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}
			>
				<MenuItem onClick={handleClose}>
					<Link to={'/admin/users'}>Потребители</Link>
				</MenuItem>
				<MenuItem onClick={handleClose}>
					<Link to={'/admin/categories'}>Категории</Link>
				</MenuItem>

				<MenuItem onClick={handleClose}>
					<Link to={'/admin/mail'}>Имейли</Link>
				</MenuItem>
				<MenuItem onClick={handleClose}>
					<Link to={'/admin/stats'}>Статистика</Link>
				</MenuItem>
				<MenuItem onClick={handleClose}>
					<Link to={'/admin/downloadCount'}>Брой сваляния</Link>
				</MenuItem>
				<MenuItem onClick={handleClose}>
					<Link to={'/admin/downloadCountUsers'}>
						Брой сваляния - потребители
					</Link>
				</MenuItem>
				<MenuItem onClick={handleClose}>
					<Link to={'/admin/dwonloadCountBooks'}>Брой сваляния - книга</Link>
				</MenuItem>
			</Menu>
		</div>
	);
}

export function createToolbarLinks(
	isAuthenticated,
	isAdmin,
	classes,
	isInMenu = false,
	handleMobileMenuClose
) {
	const links = [
		<Button
			key="ButtonCatalogue"
			startIcon={<BulletedListIcon />}
			component={NavLink}
			to={isAdmin ? '/admin/catalogue' : '/catalogue'}
			onClick={handleMobileMenuClose}
			className={isInMenu ? classes.buttonGrow : ''}
		>
			{Messages.APPBAR_BUTTON_CATALOGUE}
		</Button>,
		<Button
			key="ButtonNewTitles"
			startIcon={<NewReleasesIcon />}
			component={NavLink}
			to={isAdmin ? '/admin/newtitles' : '/newtitles'}
			onClick={handleMobileMenuClose}
			className={isInMenu ? classes.buttonGrow : ''}
		>
			{Messages.APPBAR_BUTTON_NEW_TITLES}
		</Button>,
		<Button
			key="ButtonContact"
			startIcon={<QuestionAnswerIcon />}
			component={NavLink}
			to="/contact"
			onClick={handleMobileMenuClose}
			className={isInMenu ? classes.buttonGrow : ''}
		>
			{Messages.APPBAR_BUTTON_CONTACT}
		</Button>,
		<Button
			key="ButtonHelp"
			startIcon={<HelpIcon />}
			component={NavLink}
			to="/help"
			onClick={handleMobileMenuClose}
			className={isInMenu ? classes.buttonGrow : ''}
		>
			{Messages.APPBAR_BUTTON_HELP}
		</Button>,
	];

	if (isAdmin) {
		let help = links.pop();
		links.pop();

		links.push(
			<Button
				key="ButtonAuthors"
				startIcon={<HelpIcon />}
				component={NavLink}
				to="/admin/authors"
				onClick={handleMobileMenuClose}
				className={isInMenu ? classes.buttonGrow : ''}
			>
				Автори
			</Button>,

			<Button
				key="ButtonActors"
				startIcon={<HelpIcon />}
				component={NavLink}
				to="/admin/actors"
				onClick={handleMobileMenuClose}
				className={isInMenu ? classes.buttonGrow : ''}
			>
				Актьори
			</Button>,
			<Button
				key="ButtonArchiveMonitor"
				startIcon={<ArchiveIcon />}
				component={NavLink}
				to="/admin/archive-monitor"
				onClick={handleMobileMenuClose}
				className={isInMenu ? classes.buttonGrow : ''}
			>
				{Messages.APPBAR_BUTTON_ARCHIVE_MONITOR}
			</Button>,
			<SimpleMenu handleCloseMenu={handleMobileMenuClose}></SimpleMenu>,
			help,
			<Button
				key="ButtonLogout"
				startIcon={<LogoutIcon />}
				component={NavLink}
				to="/sign-out"
				onClick={handleMobileMenuClose}
				className={isInMenu ? classes.buttonGrow : ''}
			>
				{Messages.APPBAR_BUTTON_LOGOUT}
			</Button>
		);
	} else if (isAuthenticated) {
		links.splice(
			2,
			0,
			<Button
				key="ButtonMyBooks"
				startIcon={<ImportContactsIcon />}
				component={NavLink}
				to="/mybooks"
				onClick={handleMobileMenuClose}
				className={isInMenu ? classes.buttonGrow : ''}
			>
				{Messages.APPBAR_BUTTON_MY_BOOKS}
			</Button>
		);
		links.push(
			<Button
				key="ButtonLogout"
				startIcon={<LogoutIcon />}
				component={NavLink}
				to="/sign-out"
				onClick={handleMobileMenuClose}
				className={isInMenu ? classes.buttonGrow : ''}
			>
				{Messages.APPBAR_BUTTON_LOGOUT}
			</Button>,
			<Button
				key="ButtonProfile"
				startIcon={<AccountCircleIcon />}
				component={NavLink}
				to="/profile"
				onClick={handleMobileMenuClose}
				className={isInMenu ? classes.buttonGrow : ''}
			>
				{Messages.APPBAR_BUTTON_PROFILE}
			</Button>
		);
	} else {
		links.push(
			<Button
				key="ButtonRegistration"
				startIcon={<PlusOneIcon />}
				component={NavLink}
				to="/sign-up"
				onClick={handleMobileMenuClose}
				className={isInMenu ? classes.buttonGrow : ''}
			>
				{Messages.APPBAR_BUTTON_REGISTRATION}
			</Button>
		);
		links.push(
			<Button
				key="ButtonLogin"
				startIcon={<LockOpenIcon />}
				component={NavLink}
				to="/sign-in"
				onClick={handleMobileMenuClose}
				className={isInMenu ? classes.buttonGrow : ''}
			>
				{Messages.APPBAR_BUTTON_LOGIN}
			</Button>
		);
	}

	return links;
}
